import { render, staticRenderFns } from "./MT_HAPLO_TYPE.vue?vue&type=template&id=7c63e562&"
import script from "./MT_HAPLO_TYPE.vue?vue&type=script&lang=js&"
export * from "./MT_HAPLO_TYPE.vue?vue&type=script&lang=js&"
import style0 from "./MT_HAPLO_TYPE.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports